export const GENERATE_ORDERS_REQUEST = 'GENERATE_ORDERS_REQUEST';
export const GENERATE_ORDERS_SUCCESS = 'GENERATE_ORDERS_SUCCESS';
export const GENERATE_ORDERS_ERROR = 'GENERATE_ORDERS_ERROR';
